import { BlockLayout, BlockEnums } from 'types'

export const horizontalThreeColumnAddonLayout: BlockLayout = {
  blockType: BlockEnums.HStack,
  blocks: [
    {
      blockType: BlockEnums.VStack,
      blocks: [
        { blockType: BlockEnums.Title },
        {
          blockType: BlockEnums.Subtitle,
          styleOverride: {
            color: 'gray',
          },
        },
      ],
      styleOverride: {
        flex: '0 0 20em',
        alignSelf: 'flex-start',
        alignItems: 'center',
      },
    },
    {
      blockType: BlockEnums.Features,
      styleOverride: {
        flex: '1 0 15em',
        maxWidth: '20em',
      },
    },
    {
      blockType: BlockEnums.Price,
      styleOverride: { flex: '0 0 auto', margin: '0 2em' },
    },
    {
      blockType: BlockEnums.AddRemoveButton,
      styleOverride: {
        flex: '0 0 7em',
        margin: '0 2em',
      },
    },
  ],
}

export const cardAddonLayout: BlockLayout = {
  blockType: BlockEnums.VStack,
  blocks: [
    {
      blockType: BlockEnums.Title,
    },
    {
      blockType: BlockEnums.Subtitle,
      styleOverride: {
        color: 'grey',
        alignSelf: 'center',
      },
    },
    {
      blockType: BlockEnums.Features,
    },
    {
      blockType: BlockEnums.Price,
    },
    {
      blockType: BlockEnums.AddRemoveButton,
      styleOverride: {
        alignSelf: 'center',
        width: '4em',
      },
    },
  ],
  styleOverride: {
    width: '20em',
    height: '20em',
    border: '2px solid black',
    padding: '1em',
    margin: '1em',
    borderRadius: '1em',
  },
}

export const testLayout: BlockLayout = {
  blockType: BlockEnums.HStack,
  blocks: [
    {
      blockType: BlockEnums.VStack,
      blocks: [
        {
          blockType: BlockEnums.Title,
          styleOverride: {
            color: 'red',
          },
        },
        {
          blockType: BlockEnums.Subtitle,
          styleOverride: {
            color: 'gray',
          },
        },
      ],
      styleOverride: {
        flex: '0 0 50%',
        alignItems: 'center',
      },
    },
    {
      blockType: BlockEnums.Features,
      styleOverride: {
        flex: '1 0 auto',
        width: 'fit-content',
        alignItems: 'flex-start',
      },
    },
  ],
}
